module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II1.f6a97d08.png";